import React from 'react';
import { Link } from 'react-router-dom';
import { RESEARCH_SUPPORT_BASE } from '../../constants/researchSupport';

const pillars = [
  {
    title: 'Structured submission',
    description:
      'Submit your thesis or project with clear metadata, abstracts, and supporting files through a guided application portal.',
    icon: '📄',
  },
  {
    title: 'Publication pathway',
    description:
      'Receive editorial guidance aligned with your publication goals — journals, conferences, repositories, or preprints.',
    icon: '📚',
  },
  {
    title: 'Transparent review',
    description:
      'Track status from submission through review, revision, acceptance, and publication preparation.',
    icon: '🔍',
  },
  {
    title: 'Mentor & reviewer network',
    description:
      'Work with qualified reviewers who provide constructive feedback on academic quality and presentation.',
    icon: '🎓',
  },
];

const eligibility = [
  'Undergraduate students at accredited institutions',
  'Recent graduates (typically within two years of completion)',
  'Original research, thesis, or capstone projects',
  'Commitment to ethical research and accurate citations',
];

function Overview() {
  return (
    <div className="space-y-12">
      <section className="grid md:grid-cols-2 gap-6">
        {pillars.map((item) => (
          <article
            key={item.title}
            className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:border-iof/40 transition-colors"
          >
            <span className="text-2xl mb-3 block" aria-hidden="true">
              {item.icon}
            </span>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h2>
            <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
          </article>
        ))}
      </section>

      <section className="bg-iof/5 border border-iof/20 rounded-lg p-8">
        <h2 className="text-xl font-semibold text-iof-dark mb-4">Who can apply?</h2>
        <ul className="space-y-2 text-gray-700">
          {eligibility.map((item) => (
            <li key={item} className="flex gap-2">
              <span className="text-iof">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="flex flex-col sm:flex-row gap-4">
        <Link
          to={`${RESEARCH_SUPPORT_BASE}/apply`}
          className="inline-flex justify-center items-center px-8 py-3 bg-iof text-white rounded-full font-medium hover:bg-iof-dark transition-colors"
        >
          Start your application
        </Link>
        <Link
          to={`${RESEARCH_SUPPORT_BASE}/guidelines`}
          className="inline-flex justify-center items-center px-8 py-3 border border-iof text-iof rounded-full font-medium hover:bg-iof/5 transition-colors"
        >
          Read submission guidelines
        </Link>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'EducationalOrganization',
            name: 'Intellectual Oasis Fellowship — Research Support',
            description:
              'Undergraduate research publication support, thesis mentorship, and publication assistance for students.',
            url: 'https://iofellowship.org/research-support',
            parentOrganization: {
              '@type': 'Organization',
              name: 'Intellectual Oasis Fellowship',
              url: 'https://iofellowship.org',
            },
          }),
        }}
      />
    </div>
  );
}

export default Overview;
